var _a, _b, _c, _d, _e, _f, _g, _h, _j;
import { __decorate, __metadata } from "tslib";
import fornecService from "@/core/services/fornecService";
import JwtService from "@/core/services/JwtService";
import { Mutations } from "@/store/enums/StoreEnums";
import { Horas_AdicionaisActions } from "@/store/enums/FornecEnums";
import { Module, Action, VuexModule } from "vuex-module-decorators";
let Horas_AdicionaisModule = class Horas_AdicionaisModule extends VuexModule {
    constructor() {
        super(...arguments);
        this.errors = {};
        this.isAuthenticated = !!JwtService.getToken();
    }
    [_a = Horas_AdicionaisActions.POST_HORAS_ADICIONAIS](data) {
        return new Promise(resolve => {
            fornecService.post("Horas_Adicionais/Post", data)
                .then(({ data }) => {
                resolve(data);
            })
                .catch(({ response }) => {
                this.context.commit(Mutations.SET_ERROR, response.data.errors);
            });
        });
    }
    [_b = Horas_AdicionaisActions.POST_MULTIPLE_DATES_HORAS_ADICIONAIS](data) {
        return new Promise(resolve => {
            fornecService.post("Horas_Adicionais/PostMultipleDates", data)
                .then(({ data }) => {
                resolve(data);
            })
                .catch(({ response }) => {
                this.context.commit(Mutations.SET_ERROR, response.data.errors);
            });
        });
    }
    [_c = Horas_AdicionaisActions.PUT_HORAS_ADICIONAIS](data) {
        return new Promise(resolve => {
            fornecService.put("Horas_Adicionais/Put", data)
                .then(({ data }) => {
                resolve(data);
            })
                .catch(({ response }) => {
                this.context.commit(Mutations.SET_ERROR, response.data.errors);
            });
        });
    }
    [_d = Horas_AdicionaisActions.DELETE_HORAS_ADICIONAIS](data) {
        return new Promise(resolve => {
            fornecService.delete("Horas_Adicionais/Delete", data)
                .then(({ data }) => {
                resolve(data);
            })
                .catch(({ response }) => {
                this.context.commit(Mutations.SET_ERROR, response.data.errors);
            });
        });
    }
    [_e = Horas_AdicionaisActions.DELETE_RANGE_HORAS_ADICIONAIS](data) {
        return new Promise(resolve => {
            fornecService.delete("Horas_Adicionais/DeleteRange", data)
                .then(({ data }) => {
                resolve(data);
            })
                .catch(({ response }) => {
                this.context.commit(Mutations.SET_ERROR, response.data.errors);
            });
        });
    }
    [_f = Horas_AdicionaisActions.FILTER_HORAS_ADICIONAIS](data) {
        return new Promise(resolve => {
            fornecService.post("Horas_Adicionais/Filter", data)
                .then(({ data }) => {
                resolve(data);
            })
                .catch(({ response }) => {
                this.context.commit(Mutations.SET_ERROR, response.data.errors);
            });
        });
    }
    [_g = Horas_AdicionaisActions.GET_HORAS_ADICIONAIS]() {
        return new Promise(resolve => {
            fornecService.get("Horas_Adicionais/Get")
                .then(({ data }) => {
                resolve(data);
            })
                .catch(({ response }) => {
                this.context.commit(Mutations.SET_ERROR, response.data.errors);
            });
        });
    }
    [_h = Horas_AdicionaisActions.GETWITHDISABLED_HORAS_ADICIONAIS]() {
        return new Promise(resolve => {
            fornecService.get("Horas_Adicionais/GetWithDisabled")
                .then(({ data }) => {
                resolve(data);
            })
                .catch(({ response }) => {
                this.context.commit(Mutations.SET_ERROR, response.data.errors);
            });
        });
    }
    [_j = Horas_AdicionaisActions.GET_BY_ID_HORAS_ADICIONAIS](data) {
        return new Promise(resolve => {
            fornecService.get("Horas_Adicionais/GetById", data)
                .then(({ data }) => {
                resolve(data);
            })
                .catch(({ response }) => {
                this.context.commit(Mutations.SET_ERROR, response.data.errors);
            });
        });
    }
};
__decorate([
    Action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], Horas_AdicionaisModule.prototype, _a, null);
__decorate([
    Action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], Horas_AdicionaisModule.prototype, _b, null);
__decorate([
    Action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], Horas_AdicionaisModule.prototype, _c, null);
__decorate([
    Action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], Horas_AdicionaisModule.prototype, _d, null);
__decorate([
    Action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], Horas_AdicionaisModule.prototype, _e, null);
__decorate([
    Action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], Horas_AdicionaisModule.prototype, _f, null);
__decorate([
    Action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", void 0)
], Horas_AdicionaisModule.prototype, _g, null);
__decorate([
    Action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", void 0)
], Horas_AdicionaisModule.prototype, _h, null);
__decorate([
    Action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], Horas_AdicionaisModule.prototype, _j, null);
Horas_AdicionaisModule = __decorate([
    Module
], Horas_AdicionaisModule);
export default Horas_AdicionaisModule;
//# sourceMappingURL=Horas_AdicionaisModule.js.map